var $d943521233798059$exports = {};
$d943521233798059$exports = {
    "backButton": (args)=>`Retornar a ${args.prevMenuButton}`,
    "moreActions": `Mais a\xe7\xf5es`,
    "unavailable": `Indispon\xedvel. Expanda para ver os detalhes`
};


export {$d943521233798059$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
